import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
import * as XLSX from 'xlsx';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import FeedIcon from '@mui/icons-material/Feed';
import Select from 'react-select'; // Import react-select
import CopyrightIcon from '@mui/icons-material/Copyright';
import CircularProgress from '@mui/material/CircularProgress';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';


function PurchaseSummary() {
    const [dataBill, setDataBill] = useState([]);
    const [dataItem, setDataItem] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const tableRef = React.createRef();
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const { isAuthenticated, companyId, branchId, permissions, token, logout } = useAuth();

    const [totalqty, setTotalqty] = useState(0);
    const [totalamt, setTotalamt] = useState(0);
    const [totalgst, setTotalgst] = useState(0);
    const [totalnet, setTotalnet] = useState(0);


    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        fetchTableData();
    }, [isAuthenticated, companyId, branchId, token, logout]);

    const [totalbills, setTotalbills] = useState(0);
    useEffect(() => {
        // Calculate total 
        let totalqty = 0;
        let totalamt = 0;
        let totalgst = 0;
        let totalnet = 0;
        let billNumbers = new Set();

        dataItem.forEach(item => {
            totalqty += item.Quantity;
            totalamt += item.Amount;
            totalgst += item.GSTAmount;
            totalnet += item.TotalAmount;
            billNumbers.add(item.GRNNumber);
        });
        setTotalqty(totalqty);
        setTotalamt(totalamt);
        setTotalgst(totalgst);
        setTotalnet(totalnet);
        const totalBills = billNumbers.size;
        setTotalbills(totalBills);
    }, [dataItem]);


    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };

    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        setFromDate(selectedDate);
    };

    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        setToDate(selectedDate);
    };

    const hasReadReportPermission = permissions.includes('Read Reports');
    const [loading, setLoading] = useState(false);

    const fetchTableData = async () => {
        if (hasReadReportPermission) {
            setDataItem([]);
            setLoading(true);
            try {
                const response = await fetchData('ReportApi', `/PurchaseSummary/${companyId}/${branchId}/${fromDate}/${toDate}`, token);
                if (response.responseCode === '1111') {
                    setDataItem(response.response_data);
                }
            } catch (error) {
                console.error('Error fetching Purchase Summary Details:', error);
            }
            finally {
                setLoading(false); // Hide loading screen
            }
        }
    };

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredDataItem = dataItem.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };

    // const handleExportExcel = () => {
    //     const excelData = [];
    //     const headerCaption = [`Purchase Summary From : ${formatDate(fromDate)} To : ${formatDate(toDate)}`];
    //     excelData.push(headerCaption);
    //     const headerRow = ['Purchase Type', 'GRN Date', 'GRN Number', 'LR Date', 'LR Number', 'PG', 'IG', 'ISG', 'PF', 'Item No', 'Description', 'HSN Code', 'Quantity', 'Purchase Rate', 'GST %', 'Net Value', 'GST Amount', 'Net Value + Tax', 'Comments', 'Category', 'Item Group', 'Season Code', 'Size Code'];
    //     excelData.push(headerRow);
    //     filteredDataItem.forEach((rowData, index) => {
    //         const dataRow = [];
    //         dataRow.push(rowData.PurchaseType, formatDate(rowData.GRNDate), rowData.GRNNumber, formatDate(rowData.LRDate), rowData.LRNumber, rowData.PG, rowData.IG, rowData.ISG, rowData.PF, parseFloat(rowData.Code), rowData.ItemName, rowData.HSNCode, rowData.Quantity, parseFloat(rowData.Rate.toFixed(2))
    //             , parseFloat(rowData.Amount.toFixed(2)), rowData.GSTRate, parseFloat(rowData.GSTAmount.toFixed(2)), parseFloat(rowData.TotalAmount.toFixed(2)), rowData.Remarks, rowData.CategoryName, rowData.ItemGroupName, rowData.SeasonCode, rowData.SizeCode);
    //         excelData.push(dataRow);
    //     });
    //     // Add total row
    //     const totalRow = ['', '', '', '', '', '', '', '', '', '', 'Total Bills', totalbills, totalqty, '', totalnet, '', totalgst, totalamt, '', '', ''];
    //     excelData.push(totalRow);
    //     const ws = XLSX.utils.aoa_to_sheet(excelData);
    //     const wb = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(wb, ws, 'Purchase Summary');
    //     XLSX.writeFile(wb, 'PurchaseSummary.xlsx');
    // };

    
    const handleExportExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Purchase Summary');

        // Define columns that should be right-aligned
        const rightAlignColumns = [
            'Quantity', 'Purchase Rate', 'GST %', 'Net Value',
            'GST Amount', 'Net Value + Tax', 'Total Bills', 'Total Qty',
            'Total Net', 'Total GST', 'Total Amount'
        ];

        // Caption row
        const headerCaption = `Purchase Summary From : ${formatDate(fromDate)} To : ${formatDate(toDate)}`;
        worksheet.mergeCells('A1:W1'); // Adjust range based on your header count
        const headerCaptionCell = worksheet.getCell('A1');
        headerCaptionCell.value = headerCaption;
        headerCaptionCell.font = { bold: true, size: 14 };
        headerCaptionCell.alignment = { vertical: 'middle', horizontal: 'left' };

        // Header row
        const headerRowValues = [
            'Purchase Type', 'GRN Date', 'GRN Number', 'LR Date', 'LR Number',
            'PG', 'IG', 'ISG', 'PF', 'Item No', 'Description', 'HSN Code',
            'Quantity', 'Net Value', 'GST %', 'GST Amount',
            'Net Value + Tax', 'Comments', 'Category', 'Item Group',
            'Season Code', 'Size Code'
        ];
        const headerRow = worksheet.addRow(headerRowValues);

        headerRow.eachCell((cell) => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFB6D7A8' }
            };
            cell.font = { bold: true, color: { argb: 'FF000000' } };
            cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            };
        });

        worksheet.columns = headerRowValues.map(() => ({ width: 18 }));

        // Data rows
        filteredDataItem.forEach((rowData) => {
            const dataRow = [
                rowData.PurchaseType,
                formatDate(rowData.GRNDate),
                rowData.GRNNumber,
                formatDate(rowData.LRDate),
                rowData.LRNumber,
                rowData.PG,
                rowData.IG,
                rowData.ISG,
                rowData.PF,
                parseFloat(rowData.Code),
                rowData.ItemName,
                rowData.HSNCode,
                parseFloat(rowData.Quantity),
                // parseFloat(rowData.Rate.toFixed(2)),
                parseFloat(rowData.GSTRate),
                parseFloat(rowData.Amount.toFixed(2)),                
                parseFloat(rowData.GSTAmount.toFixed(2)),
                parseFloat(rowData.TotalAmount.toFixed(2)),
                rowData.Remarks,
                rowData.CategoryName,
                rowData.ItemGroupName,
                rowData.SeasonCode,
                rowData.SizeCode
            ];

            const row = worksheet.addRow(dataRow);

            row.eachCell((cell, colNumber) => {
                const headerName = headerRowValues[colNumber - 1];
                if (rightAlignColumns.includes(headerName)) {
                    cell.alignment = { vertical: 'middle', horizontal: 'right' };
                } else {
                    cell.alignment = { vertical: 'middle', horizontal: 'center' };
                }

                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                };
            });
        });

        // Total row
        const totalRowValues = [
            '', '', '', '', '', '', '', '', '', '',
            'Total Bills', totalbills, totalqty, totalnet, '',
            totalgst, totalamt, '', '', '', '', ''
        ];
        const totalRow = worksheet.addRow(totalRowValues);

        totalRow.font = { bold: true };
        totalRow.eachCell((cell, colNumber) => {
            const headerName = headerRowValues[colNumber - 1];
            if (rightAlignColumns.includes(headerName)) {
                cell.alignment = { vertical: 'middle', horizontal: 'right' };
            } else {
                cell.alignment = { vertical: 'middle', horizontal: 'center' };
            }

            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFF2CC' }
            };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            };
        });

        // Freeze header
        worksheet.views = [{ state: 'frozen', ySplit: 2 }];

        worksheet.columns = headerRowValues.map(() => ({ width: 18 }));

        // Save file
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), 'PurchaseSummary.xlsx');
    };


    return (
        <div className="w-full  mx-auto" style={{ width: '95%', marginTop: '10px' }}>
            <div style={{ width: '100%', marginBottom: '2', display: 'flex', flexWrap: 'nowrap', alignItems: 'center' }}>
                <div className='w-full mb-2 flex' style={{ marginTop: '10px' }}>
                    <h6 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}>
                        Purchase Summary
                    </h6>
                </div>
                <div className='w-full mb-2 flex' style={{ marginTop: '10px' }}>
                    {loading && (
                        <div style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            zIndex: 9999
                        }}>
                            <div>
                                <CircularProgress style={{ color: 'white' }} />
                                <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
                            </div>
                        </div>
                    )}
                    <Button
                        style={{ color: "black", height: '36px', marginLeft: '10px' }}
                        onClick={fetchTableData}
                        className="linkcolor"
                    >
                        <IconButton onClick={fetchTableData}>
                            <RefreshIcon style={{ color: 'brown' }} />
                        </IconButton>
                        <span style={{ color: 'brown', fontWeight: 'bolder' }}>Refresh</span>
                    </Button>
                    <Button
                        style={{ color: "black", height: '36px', marginLeft: '10px' }}
                        onClick={handleExportExcel}
                        className="linkcolor"
                    >
                        <IconButton onClick={handleExportExcel}>
                            <FeedIcon style={{ color: 'darkgreen' }} />
                        </IconButton>
                        <span style={{ color: 'darkgreen', fontWeight: 'bolder' }}>Excel</span>
                    </Button>

                    <div className="watermark">
                        <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                    </div>

                    <div style={{ marginBottom: '10px', marginLeft: '20px', display: 'flex', alignItems: 'center' }}>
                        <SearchIcon onClick={toggleSearchInput} style={{ cursor: 'pointer' }} />
                        {showSearchInput && (
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="text"
                                placeholder="Search..."
                                value={searchQuery}
                                onChange={handleSearch}
                                style={{ marginLeft: '10px' }}
                            />
                        )}
                    </div>
                </div>

                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                        FromDate
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={fromDate} onChange={handleFromDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                        ToDate
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={toDate} onChange={handleToDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
            </div>

            <div className='w-full mb-5 flex' style={{ maxHeight: '550px', overflowY: 'auto', marginTop: '7px' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#08396B', Width: '2500px' }}>
                            <TableRow sx={{ whiteSpace: 'nowrap' }}>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Purchase Type</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>GRN Date</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>GRN Number</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>LR Date</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>LR Number</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>PG</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>IG</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>ISG</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>PF</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Item No</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Description</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>HSN Code</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Quantity</TableCell>
                                {/* <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Purchase Rate</TableCell> */}
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Net Value</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>GST %</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>GST Amount</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Net Value + GST</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Comments</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Category</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Item Group</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Season Code</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>Size Code</TableCell>
                            </TableRow>
                        </TableHead>

                        {/* <TableBody sx={{ backgroundColor: '#24203C' }}> */}
                        <TableBody sx={{ backgroundColor: 'whitesmoke' }}>
                            {filteredDataItem.map((data, index) => (
                                <TableRow
                                    key={data.id}
                                    className={'highlighted-row'}
                                    sx={{
                                        padding: '5px',
                                        height: '52px',

                                        backgroundColor: 'transparent',

                                    }}
                                >
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.PurchaseType}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{formatDate(data.GRNDate)}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.GRNNumber}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{formatDate(data.LRDate)}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.LRNumber}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.PG}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.IG}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.ISG}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.PF}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.Code}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.ItemName}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.HSNCode}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', fontSize: '12px', textAlign: 'right' }}>{data.Quantity}</TableCell>
                                    {/* <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', fontSize: '12px', textAlign: 'right' }}>{data.Rate.toFixed(2)}</TableCell> */}
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', fontSize: '12px', textAlign: 'right' }}>{data.Amount.toFixed(2)}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', fontSize: '12px', textAlign: 'right' }}>{data.GSTRate}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', fontSize: '12px', textAlign: 'right' }}>{data.GSTAmount.toFixed(2)}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', fontSize: '12px', textAlign: 'right' }}>{data.TotalAmount.toFixed(2)}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '12px' }}>{data.Remarks}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '12px' }}>{data.CategoryName}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '12px' }}>{data.ItemGroupName}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '12px' }}>{data.SeasonCode}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '12px' }}>{data.SizeCode}</TableCell>

                                </TableRow>
                            ))}

                            <TableRow
                                className={'highlighted-row'}
                                sx={{
                                    padding: '7px',
                                    height: '52px',

                                    backgroundColor: '#336D82',

                                }}
                            >
                                <TableCell colSpan={10} />
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', fontSize: '12px', textAlign: 'right', textTransform: 'uppercase' }}>Total Bills</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', fontSize: '12px', textAlign: 'right' }}>{totalbills.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', fontSize: '12px', textAlign: 'right' }}>{totalqty.toFixed(2)}</TableCell>
                                {/* <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', fontSize: '12px', textAlign: 'right' }}></TableCell> */}
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', fontSize: '12px', textAlign: 'right' }}>{totalnet.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', fontSize: '12px', textAlign: 'right' }}></TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', fontSize: '12px', textAlign: 'right' }}>{totalgst.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', fontSize: '12px', textAlign: 'right' }}>{totalamt.toFixed(2)}</TableCell>
                                <TableCell colSpan={6} />
                            </TableRow>

                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </div>
    );
}

export default PurchaseSummary;
